export default __webpack_public_path__ + "static/media/Sunset-Turbines-Narrow-3840px-1440px-web.9639c35c.jpg";